import { Injectable } from "@angular/core";
import { AnimationOptions } from "ngx-lottie";
@Injectable({
    providedIn: "root",
})
export class Lottie {
    info: AnimationOptions = {
        path: `../../../assets/lottie/info.json`,
    };
    loadingBlueprint: AnimationOptions = {
        path: `../../../assets/lottie/loading-blueprint.json`,
    };
    celebration: AnimationOptions = {
        path: `../../../assets/lottie/celebration.json`,
        loop: false,
        autoplay: true,
    };
    dashboardCelebration: AnimationOptions = {
        path: `../../../assets/lottie/dashboard-celebration.json`,
        loop: true,
        autoplay: true,
    };
    brandLoader: AnimationOptions = {
        path: `../../../assets/lottie/brand-loader.json`,
        loop: true,
        autoplay: true,
    };
    success: AnimationOptions = {
        path: `../../../assets/lottie/success.json`,
    };
    discountCongratulationsRed: AnimationOptions = {
        path: `../../../assets/lottie/congratulations_discount_red.json`,
    };
}
